import React, { createContext, useCallback, useContext, useState } from "react"

const isSidebarEnabledContext = createContext(true)
const setIsSidebarEnabledContext = createContext({
  open: () => {},
  close: () => {},
})

interface Props {
  children?: React.ReactNode
}
export function SidebarEnabledProvider({ children }: Props) {
  const [isEnabled, setIsEnabled] = useState<boolean>(true)

  const open = useCallback(() => {
    setIsEnabled(true)
  }, [])

  const close = useCallback(() => {
    setIsEnabled(false)
  }, [])

  return (
    <isSidebarEnabledContext.Provider value={isEnabled}>
      <setIsSidebarEnabledContext.Provider value={{ open, close }}>
        {children}
      </setIsSidebarEnabledContext.Provider>
    </isSidebarEnabledContext.Provider>
  )
}

export function useIsSidebarEnabled() {
  return useContext(isSidebarEnabledContext)
}

export function useSetIsSidebarEnabled() {
  return useContext(setIsSidebarEnabledContext)
}
